import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"my-3",attrs:{"rounded":"lg","outlined":""}},[_c(VSkeletonLoader,{attrs:{"type":"list-item-avatar-two-line"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }